import { RequestControlProps } from "../components/types/main-component";

export const hasSuccessItem = (array: RequestControlProps[]): boolean => {
    const control = array.filter((item) => {
      return item.success === true
    })
    return control[0] === undefined
  };